import { render, staticRenderFns } from "./evaluationForm.vue?vue&type=template&id=25da083c&scoped=true"
import script from "./evaluationForm.vue?vue&type=script&lang=js"
export * from "./evaluationForm.vue?vue&type=script&lang=js"
import style0 from "./evaluationForm.vue?vue&type=style&index=0&id=25da083c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25da083c",
  null
  
)

export default component.exports